import { render, staticRenderFns } from "./NewsTypeForm.vue?vue&type=template&id=186b7d87&"
import script from "./NewsTypeForm.vue?vue&type=script&lang=js&"
export * from "./NewsTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports